// extracted by mini-css-extract-plugin
export default {"cls1":"jap46HkZaYnWBe6RvjHU","cls2":"ne2z62Qs19QPcRrWd4p9 jap46HkZaYnWBe6RvjHU","twoColumn":"TTVd2iCiMEZspD9wZyGO","isTabletDown":"glndvEPzf5dCowRqX8YY"};